import { render, staticRenderFns } from "./vipMall.vue?vue&type=template&id=58a3fafc&scoped=true&"
import script from "./vipMall.vue?vue&type=script&lang=ts&"
export * from "./vipMall.vue?vue&type=script&lang=ts&"
import style0 from "./vipMall.vue?vue&type=style&index=0&id=58a3fafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a3fafc",
  null
  
)

export default component.exports